import { normalize } from 'normalizr';
import { query } from '@/dex-shared/helpers/graphql';
import { board } from '@/dex-shared/helpers/normalizr_schema';

export default {
  async PULL_ALL_BOARDS({ commit }) {
    const response = await query(`query getAllBoards{
      allBoards {
        nodes {
          id
          title
          description
          slug
          workload
        }
      }
    }`);
    const normalizedResponse = normalize(response.data.allBoards.nodes, [
      board,
    ]);
    commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
  },
};
